import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {LobbyHeaderDefaultButtonsBox} from "./lobby-header-button.default.box";
import {LobbyHeader777ButtonsBox} from "./lobby-header-button.777.box";

export const LobbyHeaderButtonsBox = styledByTheme(LobbyHeaderDefaultButtonsBox).forCasino777(LobbyHeader777ButtonsBox).apply();